import { ensureExists } from "@/lib/ensureExists";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { productLandingQueryOptions } from "@/lib/productPageQuery";
import DynamicProductLanding from "@/pages/DynamicProductLanding";

export const Route = createFileRoute("/product/$slug")({
  beforeLoad: ({ params }) => ensureExists("product_landings", params.slug),
  loader: async ({ params, context }) => {
    const landing = await context.queryClient.ensureQueryData(productLandingQueryOptions(params.slug));
    if (!landing) throw notFound();
    return { landing };
  },
  head: ({ params, loaderData }) => {
    const canonicalUrl = "https://www.garden-review.co.uk" + `/product/${params.slug}`;
    const landing = loaderData?.landing;
    if (!landing) return {};
    const description = landing.meta_description || landing.hero_description || landing.title;
    return {
      meta: [
        { title: landing.title },
        { name: "description", content: description },
        { property: "og:title", content: landing.title },
        { property: "og:description", content: description },
        { property: "og:url", content: canonicalUrl },
        { property: "og:type", content: "product" },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: landing.title },
        { name: "twitter:description", content: description },
        ...(landing.hero_image?.startsWith("https://") ? [
          { property: "og:image", content: landing.hero_image },
          { name: "twitter:image", content: landing.hero_image },
        ] : []),
      ],
      links: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
  component: DynamicProductLanding,
});
